module.exports = __webpack_public_path__ + "img/icon_5_65.54bb7eab.png";